<template>
  <section>
    <ul class="iconul">
      <li v-for="(item) in iconarray" :key="item">
        <i :class="item"></i>
        <span id="copy">{{item}}</span>
        <i @click="copy(item)" id="iconpotion" class="el-icon-Aicon-fuzhi" style="font-size:20px;vertical-align:top;background-color:#ccc;border-radius:5px;padding-top:5px;cursor:pointer"></i>
      </li>
    </ul>
  </section>
</template>
<script>
import { iconarray } from './Iconarray.js'
export default {
  data() {
    return {
      iconarray: iconarray
    }
  },
  methods: {
    copy(e) {
      let input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', e)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: '浏览器不支持拷贝请手动拷贝',
          type: 'error'
        })
      }
      document.body.removeChild(input)
    }
  }
}
</script>
<style lang='scss' scoped>
.iconul {
  list-style: none;
  text-align: center;
  li {
    text-align: center;
    display: flex;
    background-color: #fff;
    position: relative;
    justify-content: center;
    flex-direction: column;
    word-wrap: break-word;
    float: left;
    height: 121px;
    width: 145px;
    border: 1px solid #ccc;
    > i {
      font-size: 40px;
    }
    #iconpotion {
      position: absolute;
      bottom: 93px;
      width: 20%;
      opacity: 0.5;
      left: 78%;
    }
  }
}
</style>
